




























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {formatUnit} from '@/utils/unitUtils';
import {SensorCard} from '@/views/dashboard/interfaces';
import {MeasurementData} from '@/views/system/measurements/interfaces';
import {getMeasurementById} from '@/utils/moduleUtils';
import {MeasurementType} from '@/views/system/measurements/enums';
import {pmoduleDataRoutesByTypeMap} from '@/views/system/modules/configurate';
import {PModuleType} from '@/enums/configs';
import {addSignalSubscription} from '@/utils/socketUtils';
import {uuidv4} from '@/utils/uuidUtils';
import {Boundaries} from '@/views/system/modules/interfaces';

@Component({})
export default class Sensor extends Vue {
  @Prop({required: false})
  sensor!: SensorCard;

  @Prop()
  measurements!: MeasurementData[];

  @Prop()
  edit!: boolean;

  unit = '';
  bidUnit: number | null = null;

  currentValue: number | null = 0;

  boundaries: Boundaries | null = null;

  nameSensor = '';
  moduleAlias = '';
  measAlias = '';
  measurementShortName = '';

  updateDateString = '';
  updateTimeoutInMinutes = 0;
  status = 0;
  trend = '';

  id!: string;

  colors = ['#e5e5e5', '#ffcc99'];

  async created() {
    if (!this.sensor.moduleGUID || !this.sensor.measurement.id) return;
    this.id = uuidv4();

    const measurement = getMeasurementById(this.measurements, this.sensor.measurement.id);

    if (!measurement || measurement.type !== MeasurementType.Signal) return;

    const unit = formatUnit(measurement.unit);
    this.unit = unit != '-' ? unit : '';
    this.nameSensor = this.sensor.name;
    this.measurementShortName = measurement.shortName;
    this.moduleAlias = this.sensor.moduleAlias;
    this.measAlias = measurement.alias;

    this.boundaries = {
      bottomErrorBoundary: measurement.bottomErrorBoundary,
      bottomDangerBoundary: measurement.bottomDangerBoundary,
      bottomWarningBoundary: measurement.bottomWarningBoundary,
      topWarningBoundary: measurement.topWarningBoundary,
      topDangerBoundary: measurement.topDangerBoundary,
      topErrorBoundary: measurement.topErrorBoundary,
    };

    if (this.$dataSocketManager) {
      const params = {
        moduleType: this.sensor.moduleType,
        moduleGUID: this.sensor.moduleGUID,
        alias: this.sensor.measurement.alias,
        eventType: this.sensor.measurement.eventType,
      };
      const subscriptionFunction = (socket: WebSocket) =>
        addSignalSubscription.call(this, socket, params);
      const subscrName = `${params.moduleType}/${params.moduleGUID}/${params.alias}/${params.eventType}`;
      this.$dataSocketManager.addSubscription(
        this.id,
        subscrName,
        subscriptionFunction,
        this.onMessage,
      );
    }
  }

  @Watch('bidUnit')
  onBidUnitChange(id: number | null) {
    if (id && this.measurements?.length) {
      this.unit = formatUnit(this.measurements.find(item => item.id === id)?.unit ?? '');
    }
  }

  onMessage(e: any) {
    const strParse = JSON.parse(e.data);
    if (strParse) {
      const {
        value,
        status,
        timestamp,
        module_identifier,
        module_alias,
        event_type,
        bid,
      }: {
        value: number;
        status: number;
        top_boundary: number | null;
        bottom_boundary: number | null;
        timestamp: number;
        module_identifier: string;
        module_alias: string;
        event_type: string;
        bid: number;
      } = strParse;
      if (
        module_identifier !== this.sensor.moduleGUID ||
        module_alias !== this.sensor.measurement.alias ||
        event_type !== this.sensor.measurement.eventType
      ) {
        return;
      }

      if (!this.sensor) {
        console.log('Нет требуемой карты, не нужно её обновлять, но не сработала отписка');
        return;
      }
      if (timestamp) {
        const updateDate = new Date(timestamp);
        this.updateDateString = updateDate ? updateDate.toLocaleString() : '';
        this.updateTimeoutInMinutes = (new Date().getTime() - updateDate.getTime()) / 60000;
      }
      //TODO: нужно получать начальное состояние trend от сервера. Пока рисуем стрелку тренда только со второго значения.
      if (
        this.currentValue !== null &&
        this.currentValue !== undefined &&
        value !== this.currentValue
      ) {
        this.trend = value > this.currentValue ? 'up' : 'down';
      }
      // Не показываем стрелку, если пришло плохое значение
      if (value === null || value === undefined) {
        this.trend = '';
      }
      // Записываем данные в карту сенсора
      this.currentValue = value;
      this.status = status === 2 ? +!status ?? 0 : status;

      if (bid) {
        this.bidUnit = bid;
      }
    }
  }

  get colorCaption() {
    // Если данные плохие или старые, помечаем коричневым :)
    const indexColor =
      this.status === 1 || this.currentValue === null || this.updateTimeoutInMinutes > 5 ? 1 : 0;
    return this.colors[indexColor];
  }

  async link() {
    if (!this.edit) {
      const {href} = this.$router.resolve({
        name: pmoduleDataRoutesByTypeMap.get(this.sensor.moduleType),
        params: {id: `${this.sensor.pmoduleId}`},
        hash:
          PModuleType[this.sensor.moduleType] === 'DtcpAccelerometerModule'
            ? `#${this.measAlias.split('_')[0]}`
            : undefined,
      });
      window.open(href, '_blank');
    }
  }

  beforeDestroy() {
    if (this.$dataSocketManager) {
      this.$dataSocketManager.removeSubscription(this.id);
    }
  }
}
